<template>
    <v-layout
        d-flex
        row
        :class="{
            'knowledge-check-block-component': $vuetify.breakpoint.mdAndUp,
            'shadowed': $vuetify.breakpoint.smAndDown,
            'mb-4': $vuetify.breakpoint.smAndDown,
            'mb-5': $vuetify.breakpoint.mdAndUp,
        }"
    >
        <v-flex v-if="$vuetify.breakpoint.mdAndUp" md4 column
                class="knowledge-check-block knowledge-check-block-required knowledge-check-block-small pa-4"
        >
            <div class="labels">
                <labelTopic :class="classes">{{ $t(filter.label_text) }}</labelTopic>
            </div>
            <v-layout align-center justify-center column>
                <div class="knowledge-check-circle">
                    <svg v-svg
                         :symbol="filter.card_image"
                         size="133 128"
                         class="knowledge-check__icon-big mt-5"
                    />
                </div>
                <div class="section-label section-label--mandatory section-label--required">
                    {{ $t('Проверочный курс') }}
                </div>
                <div v-if="card.status !== COURSE_TYPES.COMPLETE"
                     class="mt-4"
                >
                    <svg v-svg
                         symbol="hourglass"
                         size="93 88"
                         class="knowledge-check__icon mr-2"
                         role="presentation"
                    />
                    <span class="text-uppercase">{{ $t(show_rest_time) }}</span>
                </div>
                <v-layout v-if="card.status === COURSE_TYPES.COMPLETE"
                          class="mt-4"
                >
                    <template v-if="card.completionDate">
                        <v-flex>
                            <svg v-svg
                                 symbol="completed"
                                 size="16"
                                 class="knowledge-check__icon mr-2"
                                 role="presentation"
                            />
                        </v-flex>
                        <v-flex class="text-uppercase">
                            {{ $t("тест успешно сдан") }} <br>
                            {{ card.completionDate }}
                        </v-flex>
                    </template>
                    <template v-else>
                        <v-flex class="text-uppercase">
                            {{ $t("тест не сдан") }}
                        </v-flex>
                    </template>
                </v-layout>
            </v-layout>
        </v-flex>

        <v-flex v-if="$vuetify.breakpoint.mdAndUp" md8 column
                class="pa-4"
        >
            <v-layout d-flex row wrap
                      align-center
                      class="justify-space-between"
            >
                <div class="knowledge-check__date-text">

                    <v-layout row md3 class="mr-4 ">
                        <svg v-svg
                             symbol="schedule"
                             class="knowledge-check__icon knowledge-check__icon-red mr-2"
                             role="presentation"
                        />
                        <v-flex class="red-text ">{{ card.appointmentPeriod }}</v-flex>
                    </v-layout>
                </div>

                <v-layout row>
                    <svg v-svg
                         symbol="series"
                         class="knowledge-check__icon knowledge-check__icon-grey mr-2"
                         role="presentation"
                    />
                    <v-flex>
                        <span>{{ $t('Проверочный курс') }}</span>
                    </v-flex>
                </v-layout>
                <v-flex
                    md6
                    justify-end
                    text-md-right
                    text-xs-left
                >
                    <router-link v-if="card.status !== COURSE_TYPES.COMPLETE" class="link link--red" :to="{name:'course_content', params: {id: card.id, card_number: card_number}}">
                        {{ $t("Подробнее о курсе") }}
                    </router-link>
                </v-flex>
            </v-layout>
            <div class="knowledge-check__title mt-5 mb-5">{{ card.name }}</div>
            <v-layout justify-space-between row
                      wrap class="align-sm-stretch"
            >
                <v-flex>
                    <router-link v-if="isCardIncomplete()"
                                 :to="{name:'knowledge_check_detail', params: {id: card.id, card_number: card_number}}"
                                 :class="{'layout': $vuetify.breakpoint.xs}"
                    >
                        <buttonRed :disabled="disabledButton" v-text="$t(buttonText)" />
                    </router-link>
                    <div v-if="blockCourse" class="mt-2">{{ $t("Вы начали другой курс") }}</div>
                </v-flex>
                <v-flex v-if="card.status !== COURSE_TYPES.NEW" d-flex align-center
                        justify-end
                >
                    <v-flex
                        d-flex
                        class="justify-end mr-3"
                    >
                        Получено баллов: <br> {{ card.correctAnswers*5 || 0 }} из {{ card.totalQuestions*5 || 0 }}
                    </v-flex>
                    <div class="d-flex justify-end">
                        <v-progress-circular
                            :rotate="-90"
                            :size="64"
                            :width="6"
                            :value="card.completionPercent || 0"
                            :color="card.completionPercent >= 100 ? '#44b69e' : '#e2173d'"
                        >
                            {{ card.completionPercent || 0 }}%
                        </v-progress-circular>
                    </div>
                </v-flex>
            </v-layout>
        </v-flex>

        <v-flex v-if="$vuetify.breakpoint.smAndDown" column px-4
                py-4
        >
            <labelTopic :class="classes">{{ $t(filter.label_text) }}</labelTopic>
            <div class="title my-3">{{ card.name }}</div>
            <router-link class="link link--red" :to="{name:'course_content', params: {id: card.id, card_number: card_number}}">
                {{ $t("Подробнее о курсе") }}
            </router-link>
            <div v-if="card.status !== COURSE_TYPES.COMPLETE"
                 class="mt-4 mb-3 text-uppercase"
            >
                <svg v-svg
                     symbol="hourglass"
                     size="93 88"
                     class="knowledge-check__icon knowledge-check__icon-grey mr-2"
                     role="presentation"
                />
                <span class="text-uppercase">{{ show_rest_time }}</span>
            </div>
            <v-layout
                v-if="card.status === COURSE_TYPES.COMPLETE"
                class="mt-4 mb-3"
            >
                <v-layout v-if="card.completionDate" class="green-text">
                    <svg v-svg
                         symbol="completed"
                         size="16"
                         class="knowledge-check__icon mr-2 green-text"
                         role="presentation"
                    />
                    <v-flex class="text-uppercase green-text">
                        {{ $t("тест успешно сдан") }}: {{ card.completionDate }}
                    </v-flex>
                </v-layout>
                <v-flex v-else class="text-uppercase red-text">
                    {{ $t("тест не сдан") }}
                </v-flex>
            </v-layout>
            <v-layout
                row
                class="mr-4 mb-3"
            >
                <svg v-svg
                     symbol="schedule"
                     class="knowledge-check__icon knowledge-check__icon-red mr-2"
                     role="presentation"
                />
                <v-flex class="red-text">{{ card.appointmentPeriod }}</v-flex>
            </v-layout>
            <v-layout row>
                <svg v-svg
                     symbol="series"
                     class="knowledge-check__icon knowledge-check__icon-grey mr-2"
                     role="presentation"
                />
                <v-flex>
                    <span>{{ $t('Проверочный курс') }}</span>
                </v-flex>
            </v-layout>
            <v-layout column mt-4>
                <v-flex>
                    <router-link :to="{name:'knowledge_check_detail', params: {id: card.id, card_number: card_number}}" :class="{'layout': $vuetify.breakpoint.xs}">
                        <buttonRed :disabled="blockCourse" :class="{'flex xs12': $vuetify.breakpoint.xs}" v-text="$t(buttonText)" />
                    </router-link>
                    <div v-if="blockCourse" class="mt-2">{{ $t("Вы начали другой курс") }}</div>
                </v-flex>
                <v-flex v-if="card.status !== COURSE_TYPES.NEW" column
                        mt-4
                >
                    <v-flex justify-space-between d-flex>
                        <span>
                            {{ $t('Пройдено разделов {points}/{total}', {
                                'points': card.correctAnswers || 0,
                                'total': card.totalQuestions || 0,
                            }) }}
                        </span>
                        <span class="text-xs-right">{{ card.completionPercent || 0 }}%</span>
                    </v-flex>
                    <v-flex>
                        <v-progress-linear
                            :size="64"
                            :width="4"
                            :value="card.completionPercent || 0"
                            class="mt-2 mb-0 knowledge-check__progress-linear"
                            :color="card.completionPercent >= 100 ? '#44b69e' : '#e2173d'"
                        />
                    </v-flex>
                </v-flex>
            </v-layout>
        </v-flex>
    </v-layout>
</template>

<script>
import buttonRed from '@/components/ui/buttons/button_red.vue';
import labelTopic from '@/components/ui/labels/label_topic.vue';
import {mapState} from 'vuex';
import {COURSE_TYPES} from '@/modules/Knowledge_check/Knowledge_check';
import {getDeclension} from '@/lib/helpers';

export default {
  name      : 'KnowledgeCheckCard',
  components: {
    buttonRed,
    labelTopic,
  },
  props: {
    card: {
      type: Object,
    },
    courseType: {
      type: String,
    },
    filter: {
      type: Object,
    },
    card_number: {
      type: Number,
    },
  },
  data() {
    return {
      COURSE_TYPES,
    };
  },
  computed: {
    ...mapState('course_info', [
      'interrupt_test',
    ]),
    ...mapState('testing', [
      'timer',
    ]),
    disabledButton() {
      const lostAttempts = this.card.test_attempts === 0 && !this.blockCourse;

      return (lostAttempts || this.blockCourse) && this.card.type !== 'finished';
    },
    blockCourse() {
      let block = false;

      if (this.interrupt_test === false && !!this.timer.course_id) {
        if (parseInt(this.id) !== parseInt(this.timer.course_id)) {
          block = true;
        }
      }

      return block;
    },
    classes() {
      const obj = {
        [COURSE_TYPES.NEW]     : 'section-label--green',
        [COURSE_TYPES.COMPLETE]: 'section-label--grey',
        [COURSE_TYPES.EXPIRED] : this.$vuetify.breakpoint.smAndDown ? 'section-label--light-grey' : 'section-label--white',
        [COURSE_TYPES.ACTIVE]  : this.$vuetify.breakpoint.smAndDown ? 'section-label--light-grey' : 'section-label--white',
      };

      return obj[this.card.status];
    },
    buttonText: function() {
      let text ='';
      if (this.card.status === COURSE_TYPES.ACTIVE) {
        text = 'Продолжить курс';
      } else if (this.card.status === COURSE_TYPES.NEW) {
        text = 'Пройти курс';
      } else if (this.card.status === COURSE_TYPES.COMPLETE) {
        text = 'Посмотреть курс';
      } else {
        text = 'Продолжить курс';
      }

      return text;
    },
    show_rest_time() {
      if (this.card.daysUntilExpire === 0) {
        return 'Просрочен';
      } else {
        return `${getDeclension(this.card.daysUntilExpire, 'Остался', 'Осталось', 'Осталось')} ${this.card.daysUntilExpire} ${getDeclension(this.card.daysUntilExpire, 'день', 'дня', 'дней')}`;
      }
    },
  },
  methods: {
    isCardIncomplete() {
      const incompleteStatuses = [COURSE_TYPES.COMPLETE, !COURSE_TYPES.EXPIRED];
      return !incompleteStatuses.includes(this.card.status);
    },
  },
};
</script>

<style>
.knowledge-check__date-text {
    max-width: 39%;
}
</style>
